export default "__VITE_ASSET__9c267551__"